import { ProductNode, ProductPack, Event } from '@datamodel';
import service from '@services';
const PREFIX = '/events';

export const getMenu = async (pk) => {
    const response = await service.get(`${PREFIX}/${pk}/menu/`);
    console.log(response);
    if (response.status === 'ok') {
        return {
            status: 'ok',
            menu: ProductNode.parse(response.response.menu),
            packRoots: ProductNode.parseArray(response.response.pack_roots)
        }
    }
    return service.error(response);
}

export const getPacks = async (pk) => {
    const response = await service.get(`${PREFIX}/${pk}/menu_packs/`);
    if (response.status === 'ok') {
        return {
            status: 'ok',
            packs: ProductPack.parseArray(response.response),
        }
    }
    return service.error(response);
}

export const get = async (pk) => {
    const response = await service.get(`${PREFIX}/${pk}/details`);
    if (response.status === 'ok') {
        return {
            status: 'ok',
            event: Event.parse(response.response),
        }
    }
    return service.error(response);
}
